












import { Component, Prop, Vue } from "vue-property-decorator";
import * as def from "@/definitions";

import { BarcodeLayer } from "@/model/document2/page/surface/design/layer/barcodeLayer";

@Component({
    components: {
    }
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class BarcodeShowController extends Vue 
{
    @Prop() layer! : BarcodeLayer;

    private static readonly SHOW_NUMBER_ON = "表示する";
    private static readonly SHOW_NUMBER_OFF = "表示しない";

    private get showNumberText()
    {
        return this.layer.showNumber ? BarcodeShowController.SHOW_NUMBER_ON : BarcodeShowController.SHOW_NUMBER_OFF;
    }

    private changeShowNumber()
    {
        this.changeLayerProperty("showNumber", !this.layer.showNumber, true, true);
    }

    private changeLayerProperty(propertyName : string, value : any, isFinish : boolean, isOnce : boolean)
    {
        this.$emit("changeLayerProperty", propertyName, value, isFinish, isOnce);
    }
}
